import { Platform, Linking } from "react-native";

export enum UrlType {
    Phone = "PHONE",
    Sms = "SMS",
    Website = "WEBSITE",
    Url = "URL",
    Address = "ADDRESS",
}
export const useOpenUrl = () => {
    const openUrl = async (type: UrlType, resource) => {
        let url;
        switch (type) {
            case UrlType.Phone: {
                const { phoneNumber } = resource;
                url = `tel:+${phoneNumber}`;
                break;
            }

            case UrlType.Sms: {
                const { smsNumber, smsPrefill } = resource;
                url = `sms:+${smsNumber}?&body=${encodeURIComponent(
                    smsPrefill || "",
                )}`;
                break;
            }

            case UrlType.Address: {
                const { streetAddress, city, state, zipCode, title } = resource;
                const address = encodeURIComponent(
                    [title, ",", streetAddress, city, state, zipCode].join(" "),
                );
                url = `geo:0,0?q=${address}`;
                break;
            }

            case UrlType.Website:
            case UrlType.Url:
                url = resource.websiteUrl;
                break;
        }

        const isSupported = await Linking.canOpenURL(url);

        if (isSupported) {
            try {
                await Linking.openURL(url);
            } catch (error) {
                console.error("Couldn't open URL: ", error);
            }
        } else {
            console.warn(`URL ${url} isn't supported`);
        }
        return;
    };
    return openUrl;
};
